import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { useQueryState } from 'nuqs'

import { openIncidentDrawer, setIncident } from '@/redux/ui/uiSlice'

type openIncidentArgs = {
  incidentId: string
  displayId: string
}

export const useOpenIncident = () => {
  const dispatch = useDispatch()
  const [, setDisplayId] = useQueryState('displayId')

  const openAlertIncidentDrawer = useCallback(
    (id: string) => {
      dispatch(setIncident({ id }))
      dispatch(openIncidentDrawer())
    },
    [dispatch]
  )

  const openIncident = useCallback(
    (args: openIncidentArgs) => {
      openAlertIncidentDrawer(args.incidentId)
      setDisplayId(args.displayId)
    },
    [openAlertIncidentDrawer, setDisplayId]
  )

  return { openIncident, setDisplayId, openAlertIncidentDrawer }
}
